
import React, {  } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import rongyu from "../../static/images/rongyu.png"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'3'} />
        <AboutTitle name={'荣誉证书'} english={'PARTNER'}  />
        <div className='aboutImg'>
          <div style={{width:'1200px', margin:'0px auto', textAlign:'left'}}><img src={rongyu} width={'40%'} /></div>
        </div>
      </PageBox>
    </>
    
  );
}
